import unifapImage from "./unifapImage";
import sortArray from "sort-array";
import gendersList from "../utils/genders.js"
import ufsList from "../utils/ufs.js"

// import momentjs from "moment";
let pdfMake = require("pdfmake/build/pdfmake");
let pdfFonts = require("pdfmake/build/vfs_fonts");
pdfMake.vfs = pdfFonts.pdfMake.vfs;


//porcentagem: (valor/total)x100
export default function (ps, inscriptions) {
  let totalInscritos = 0;
  let totalVagas = 0;
  let totalGeneros = {};
  let totalTiposVaga = {};
  let totalEstado = {};
  let totalBonificacao = {};
  let totalPagante = {};
  const coursesList = ps.subprocesses[0].courses.map(e => e.title)
  const inscriptionsPerCourse = {};
  const genders = gendersList;
  const ufs = ufsList;
  const tiposVaga = ps.subprocesses[0].vacancies.map(e => e.title);
  let bonificacoes = [];
  let pagantes = ["Pagamento confirmado", "Isenção deferida"];
  if (ps.bonifications.length > 0) {
    bonificacoes = ps.bonifications.map(e => e.title);
    bonificacoes.push("Bonificação deferida");
  }

  if (ps.is_paid) {
    inscriptions = inscriptions.filter(e => e.is_paid || e.accepted_isencao);
  }

  for (const course of coursesList) {
    inscriptionsPerCourse[course] = {
      gender: {}, vaga: {}, inscritos: 0, procedencia: {}, bonificacao: {}, pagante: {},
    }
    if (ps.bonifications.length > 0) {
      for (const bonificacao of bonificacoes) {
        inscriptionsPerCourse[course]["bonificacao"][bonificacao] = 0;
        totalBonificacao[bonificacao] = 0;
      }
    }
    if (ps.is_paid) {
      for (const pagante of pagantes) {
        inscriptionsPerCourse[course]["pagante"][pagante] = 0;
        totalPagante[pagante] = 0;
      }
    }
    for (const gender of genders) {
      inscriptionsPerCourse[course]["gender"][gender] = 0;
      totalGeneros[gender] = 0;
    }
    for (const uf of ufs) {
      inscriptionsPerCourse[course]["procedencia"][uf.sigla] = 0;
      totalEstado[uf.sigla] = 0;
    }
    for (const vaga of ps.subprocesses[0].vacancies) {
      inscriptionsPerCourse[course]["vaga"][vaga.title] = 0;
      totalTiposVaga[vaga.title] = 0;
    }
  }
  for (const inscription of inscriptions) {
    if (inscriptionsPerCourse[inscription.course]) {
      const userGender = genders.includes(inscription.id_user && inscription.id_user.gender)
        ? inscription.id_user.gender
        : genders[genders.length - 1];
      const userState = ufs.some(u => u.sigla === (inscription.id_user && inscription.id_user.state))
        ? inscription.id_user.state
        : null;
      totalInscritos += 1;
      inscriptionsPerCourse[inscription.course]["inscritos"] += 1;
      inscriptionsPerCourse[inscription.course]["gender"][userGender] += 1;
      if (inscription.vacancie && inscriptionsPerCourse[inscription.course]["vaga"][inscription.vacancie.title] !== undefined) {
        inscriptionsPerCourse[inscription.course]["vaga"][inscription.vacancie.title] += 1;
        totalTiposVaga[inscription.vacancie.title] += 1;
      }

      if (ps.bonifications.length > 0 && inscription.bonification && inscriptionsPerCourse[inscription.course]["bonificacao"][inscription.bonification.title] !== undefined) {
        inscriptionsPerCourse[inscription.course]["bonificacao"][inscription.bonification.title] += 1;
        totalBonificacao[inscription.bonification.title] += 1;
        if (inscription.bonification_accepted) {
          inscriptionsPerCourse[inscription.course]["bonificacao"][bonificacoes[bonificacoes.length - 1]] += 1;
          totalBonificacao[bonificacoes[bonificacoes.length - 1]] += 1;
        }
      }

      if (ps.is_paid) {
        if (inscription.is_paid) {
          inscriptionsPerCourse[inscription.course]["pagante"][pagantes[0]] += 1;
          totalPagante[pagantes[0]] += 1;
        } else if (inscription.accepted_isencao) {
          inscriptionsPerCourse[inscription.course]["pagante"][pagantes[1]] += 1;
          totalPagante[pagantes[1]] += 1;
        }
      }

      totalGeneros[userGender] += 1;
      if (userState) {
        inscriptionsPerCourse[inscription.course]["procedencia"][userState] += 1;
        totalEstado[userState] += 1;
      }
    }
  }

  const courses = Object.keys(inscriptionsPerCourse);
  const inscriptionsPerCourseFormated = [];
  const inscriptionsPerGeneroFormated = [];
  const inscriptionsPerVagaFormated = [];
  const inscriptionsPerBonificacaoFormated = [];
  const inscriptionsPerPaganteFormated = [];
  const inscriptionsPerUFFormated = [];
  for (const course of courses) {
    let vagas = ps.subprocesses[0].courses.filter(c => c.title === course)[0]
    totalVagas = totalVagas + parseInt(vagas.vacancies.total);

    inscriptionsPerCourseFormated.push([{ text: course, fontSize: 10 },
    { text: inscriptionsPerCourse[course].inscritos, alignment: "center", fontSize: 10 },
    { text: vagas.vacancies.total, alignment: "center", fontSize: 10 },
    { text: (inscriptionsPerCourse[course].inscritos / vagas.vacancies.total).toFixed(1), alignment: "center", fontSize: 10 },
    ]);

    inscriptionsPerGeneroFormated.push([{ text: course, fontSize: 10 },
    ...genders.map(e => inscriptionsPerCourse[course].gender[e]).map(e => { return { text: `${e} (${((e / inscriptionsPerCourse[course].inscritos) * 100).toFixed(0)}%)`, alignment: "center", fontSize: 10 } })]);

    inscriptionsPerVagaFormated.push([{ text: course, fontSize: 10 },
    ...tiposVaga.map(e => inscriptionsPerCourse[course].vaga[e]).map(e => { return { text: `${e} (${((e / inscriptionsPerCourse[course].inscritos) * 100).toFixed(0)}%)`, alignment: "center", fontSize: 10 } })]);

    if (ps.bonifications.length > 0) {
      inscriptionsPerBonificacaoFormated.push([{ text: course, fontSize: 10 },
      ...bonificacoes.map(e => inscriptionsPerCourse[course].bonificacao[e]).map(e => { return { text: `${e} (${((e / inscriptionsPerCourse[course].inscritos) * 100).toFixed(0)}%)`, alignment: "center", fontSize: 10 } })]);
    }

    if (ps.is_paid) {
      inscriptionsPerPaganteFormated.push([{ text: course, fontSize: 10 },
      ...pagantes.map(e => inscriptionsPerCourse[course].pagante[e]).map(e => { return { text: `${e} (${((e / inscriptionsPerCourse[course].inscritos) * 100).toFixed(0)}%)`, alignment: "center", fontSize: 10 } })]);
    }

    inscriptionsPerUFFormated.push([{ text: course, fontSize: 10 },
    ...ufs.map(e => inscriptionsPerCourse[course].procedencia[e.sigla]).map(e => { return { text: e === undefined ? "0" : `${e} (${((e / inscriptionsPerCourse[course].inscritos) * 100).toFixed(0)}%)`, alignment: "center", fontSize: 7 } })]);
  }

  totalGeneros = Object.keys(totalGeneros).map(e => { return { text: `${totalGeneros[e]} (${((totalGeneros[e] / totalInscritos) * 100).toFixed(0)}%)`, alignment: "center", bold: true, fontSize: 10 } });
  totalTiposVaga = Object.keys(totalTiposVaga).map(e => { return { text: `${totalTiposVaga[e]} (${((totalTiposVaga[e] / totalInscritos) * 100).toFixed(0)}%)`, alignment: "center", bold: true, fontSize: 10 } });
  totalEstado = Object.keys(totalEstado).map(e => { return { text: `${totalEstado[e]} (${((totalEstado[e] / totalInscritos) * 100).toFixed(0)}%)`, alignment: "center", bold: true, fontSize: 7 } });
  if (ps.bonifications.length > 0) {
    totalBonificacao = Object.keys(totalBonificacao).map(e => { return { text: `${totalBonificacao[e]} (${((totalBonificacao[e] / totalInscritos) * 100).toFixed(0)}%)`, alignment: "center", bold: true, fontSize: 10 } });
  }
  if (ps.is_paid) {
    totalPagante = Object.keys(totalPagante).map(e => { return { text: `${totalPagante[e]} (${((totalPagante[e] / totalInscritos) * 100).toFixed(0)}%)`, alignment: "center", bold: true, fontSize: 10 } });
  }

  const perCourseSorted = sortArray(inscriptionsPerCourseFormated, {
    by: [0],
    order: "asc",
  });

  const perGeneroSorted = sortArray(inscriptionsPerGeneroFormated, {
    by: [0],
    order: "asc",
  });

  const perVagaSorted = sortArray(inscriptionsPerVagaFormated, {
    by: [0],
    order: "asc",
  });

  const perUFSorted = sortArray(inscriptionsPerUFFormated, {
    by: [0],
    order: "asc",
  });

  const perBonificacaoSorted = sortArray(inscriptionsPerBonificacaoFormated, {
    by: [0],
    order: "asc",
  });

  const perPagamentoSorted = sortArray(inscriptionsPerPaganteFormated, {
    by: [0],
    order: "asc",
  });

  let bonificacaoPages;
  let pagamentoPages;
  if (ps.bonifications.length > 0) {
    bonificacaoPages = [{ text: "", pageBreak: "before" },
    { text: "PERFIL DOS INSCRITOS POR BONIFICAÇÃO", alignment: "center", bold: true },
    {
      table: {
        headerRows: 1,
        widths: ["*", ...Array(bonificacoes.length).fill(60)],
        body: [
          [
            {
              text: "CURSO",
              alignment: "center",
              bold: true,
              fontSize: 6,
            },
            ...bonificacoes.map(e => { return { text: e, alignment: "center", bold: true, fontSize: 8 } })
            ,
          ],
          ...perBonificacaoSorted,
          [
            { text: "TOTAIS", alignment: "right", bold: true, fontSize: 10 },
            ...totalBonificacao,
          ],
        ],
      },
    },];
  }

  if (ps.is_paid) {
    pagamentoPages = [{ text: "", pageBreak: "before" },
    { text: "PERFIL DOS INSCRITOS POR PAGAMENTO", alignment: "center", bold: true },
    {
      table: {
        headerRows: 1,
        widths: ["*", ...Array(pagantes.length).fill(60)],
        body: [
          [
            {
              text: "CURSO",
              alignment: "center",
              bold: true,
              fontSize: 6,
            },
            ...pagantes.map(e => { return { text: e, alignment: "center", bold: true, fontSize: 8 } })
            ,
          ],
          ...perPagamentoSorted,
          [
            { text: "TOTAIS", alignment: "right", bold: true, fontSize: 10 },
            ...totalPagante,
          ],
        ],
      },
    },];
  }

  let doc = {
    content: [
      { text: " ", fontSize: 8 },
      { text: ps.title, alignment: "center", bold: true },
      { text: " ", fontSize: 8 },
      { text: "DADOS GERAIS DE INSCRITOS POR CURSO", alignment: "center", bold: true },
      {
        table: {
          headerRows: 1,
          widths: ["*", 65, 65, 100],
          body: [
            [
              {
                text: "CURSO",
                alignment: "center",
                bold: true,
              },
              {
                text: "INSCRITOS",
                alignment: "center",
                bold: true,
              },
              {
                text: "VAGAS",
                alignment: "center",
                bold: true,
              },
              {
                text: "CANDIDATOS POR VAGA",
                alignment: "center",
                bold: true,
              },
            ],
            ...perCourseSorted,
            [{ text: "TOTAIS", alignment: "right", bold: true, fontSize: 10 },
            { text: totalInscritos, alignment: "center", bold: true, fontSize: 10 },
            { text: totalVagas, alignment: "center", bold: true, fontSize: 10 },
            { text: (totalInscritos / totalVagas).toFixed(1), alignment: "center", bold: true, fontSize: 10 }]

          ],
        },
      },
      { text: "", pageBreak: "before" },
      { text: "PERFIL DOS INSCRITOS POR GÊNERO", alignment: "center", bold: true },
      {
        table: {
          headerRows: 1,
          widths: ["*", ...Array(totalGeneros.length).fill(40)],
          body: [
            [
              {
                text: "CURSO",
                alignment: "center",
                bold: true,
                fontSize: 6,
              },
              ...genders.map(e => { return { text: e, alignment: "center", bold: true, fontSize: 8 } })
              ,
            ],
            ...perGeneroSorted,
            [
              { text: "TOTAIS", alignment: "right", bold: true, fontSize: 10 },
              ...totalGeneros,
            ],
          ],
        },
      },
      { text: "", pageBreak: "before" },
      { text: "PERFIL DOS INSCRITOS POR TIPO DE VAGA", alignment: "center", bold: true },
      {
        table: {
          headerRows: 1,
          widths: ['*', ...Array(tiposVaga.length).fill(40)],
          body: [
            [
              {
                text: "CURSO",
                alignment: "center",
                bold: true,
                fontSize: 8,
              },
              ...tiposVaga.map(e => { return { text: e, alignment: "center", bold: true, fontSize: 8 } })
              ,
            ],
            ...perVagaSorted,
            [
              { text: "TOTAIS", alignment: "right", bold: true, fontSize: 10 },
              ...totalTiposVaga,
            ],
          ],
        },
      },
      { text: "", pageBreak: "before" },
      { text: "PROCEDÊNCIA GEOGRÁFICA DOS INSCRITOS", alignment: "center", bold: true },
      {
        table: {
          headerRows: 1,
          widths: ['*', ...Array(totalEstado.length).fill(15)],
          body: [
            [
              {
                text: "CURSO",
                alignment: "center",
                bold: true,
                fontSize: 8,
              },
              ...ufs.map(e => { return { text: e.sigla, alignment: "center", bold: true, fontSize: 8 } })
              ,
            ],
            ...perUFSorted,
            [
              { text: "TOTAIS", alignment: "right", bold: true, fontSize: 10 },
              ...totalEstado,
            ],
          ],
        },
      },
      ...(bonificacaoPages || []),
      ...(pagamentoPages || []),
    ].filter(Boolean),
  };
  doc.pageOrientation = "landscape";
  doc.pageMargins = [40, 100, 40, 60];
  doc.header = {
    margin: 10,
    alignment: "center",
    columns: [
      [
        {
          width: 20,
          image: unifapImage,
        },
        { text: "MINISTÉRIO DA EDUCAÇÃO", bold: true },
        { text: "UNIVERSIDADE FEDERAL DO AMAPÁ", bold: true },
        {
          text: "DEPARTAMENTO DE PROCESSOS SELETIVOS E CONCURSOS",
          alignment: "center",
          bold: true,
        },
        {
          text:
            "Rod. Juscelino Kubitschek Km 2, Jardim Marco Zero – Macapá-AP, CEP 68.903-419 www.unifap.br",
          fontSize: 8,
        },
      ],
    ],
  };
  pdfMake.createPdf(doc).download(`Relatório de Inscritos - ${ps.title}.pdf`);
}
